import React, { PureComponent } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { PageView, Button } from '@jg/react-tracking';
import Alert from '@jg/alert';
import { Helmet } from 'react-helmet';
import { Trans, withTranslation } from 'react-i18next';
import {
  IStoryComponentDispatchToProps,
  IStoryComponentMapStateToProps,
  TStory,
  IStoryFormProps,
} from './Story.d';
import {
  apiThunk as apiThunkAction,
  appThunk as appThunkAction,
  httpActions,
} from '../../actions';
import {
  getRequestInFlight,
  getRequestError,
} from '../../selectors/httpSelectors';
import { IAppState } from '../../types/state.d';
import { REQUEST, ROUTES } from '../../consts';
import StoryForm from '../../components/StoryForm';
import StepNavigation from '../../components/StepNavigation';
import { getStory, getHeroImage } from '../../selectors/apiSelectors';

export class Story extends PureComponent<TStory> {
  handleSubmit = async (data: IStoryFormProps) => {
    const { updateStory, pushToPage } = this.props;
    try {
      await updateStory(data);
      pushToPage(ROUTES.TEAM_SETTINGS);
    } catch (error) {
      // Error handled by thunk
    }
  };

  render() {
    const {
      t,
      isInFlight,
      isError,
      resetRequestError,
      story,
      heroImage,
      pushToPage,
    } = this.props;

    return (
      <PageView
        trackingData={{
          subtype: 'page creation',
          event_value: 'whats the story',
          page_section: 'page creation > whats the story',
        }}
      >
        <Helmet title={t('title.createTeam.yourStory')} />
        <main>
          <StepNavigation
            currentStep={3}
            onBackButtonClick={() => pushToPage(ROUTES.YOUR_FUNDRAISING_CAUSE)}
            trackingData={{
              action_name: 'link click',
              subtype: 'button',
              event: 'link click',
              event_value: 'back',
              page_section: 'page creation > whats the story',
            }}
          />
          <div className="jg-text--center">
            <h1>
              <Trans i18nKey="content.story.heading" />
            </h1>
            <p className="jg-text--large jg-space-mbml">
              <Trans i18nKey="content.story.subtext" />
            </p>
          </div>
          <Formik<IStoryFormProps>
            initialValues={{
              story,
              heroImage,
            }}
            onSubmit={this.handleSubmit}
            render={
              /* istanbul ignore next */ formikProps => (
                <StoryForm
                  isInFlight={isInFlight}
                  isError={isError}
                  {...formikProps}
                  id="team-story"
                />
              )
            }
          />
          {isError && (
            <Alert
              type="error"
              displayType="inline"
              onClose={resetRequestError}
            >
              <Trans i18nKey="global.error.fatal" />
            </Alert>
          )}
          <div className="jg-space-mlsm jg-space-mrsm jg-space-pbml jg-tc-button-container jg-text--center">
            <Button
              type="button"
              data-qa="skip-link"
              onClick={() => pushToPage(ROUTES.TEAM_SETTINGS)}
              className="jg-btn--invisible jg-text--link"
              trackingData={{
                action_name: 'link click',
                subtype: 'hyperlink',
                event: 'link click',
                event_value: 'skip this step',
                page_section: 'page creation > whats the story',
              }}
            >
              <Trans i18nKey="global.link.skipstep" />
            </Button>
          </div>
        </main>
      </PageView>
    );
  }
}

export const mapStateToProps = (
  state: IAppState,
): IStoryComponentMapStateToProps => ({
  isInFlight: getRequestInFlight(REQUEST.UPDATE_STORY_DATA)(state),
  isError: getRequestError(REQUEST.UPDATE_STORY_DATA)(state),
  story: getStory(state),
  heroImage: getHeroImage(state),
});

export const mapDispatchToProps: IStoryComponentDispatchToProps = {
  updateStory: apiThunkAction.updateStory,
  pushToPage: appThunkAction.pushToPage,
  resetRequestError: httpActions.resetRequestError,
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Story),
);
